import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useDocumentTitle } from '@hooks';
import cx from 'clsx';
import { useTheme } from '../../ThemeProvider';
import PageBase from '../../components/PageBase/PageBase';
import Credits from './Credits';
import Application from './Application';
import Contributors from './Contributors/Contributors';
import classes from './About.styles.less';
export default function About() {
    useDocumentTitle('About Omatsuri');
    const [theme] = useTheme();
    return (_jsx(PageBase, { children: _jsxs("div", { className: cx(classes.about, classes[theme]), children: [_jsx(Application, {}), _jsx(Contributors, {}), _jsx(Credits, {})] }) }));
}
